import * as videoConstants from "../constants/videoConstants";

export const videosReducer = (
  state = { loading: true, videos: [], type: "NOTHING_HAPPENED" },
  action
) => {
  switch (action.type) {
    case videoConstants.VIDEO_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        type: videoConstants.VIDEO_LIST_REQUEST,
      };
    case videoConstants.VIDEO_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        videos: action.payload.data,
        type: videoConstants.VIDEO_LIST_SUCCESS,
      };
    case videoConstants.VIDEO_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        type: videoConstants.VIDEO_LIST_FAIL,
      };
    case videoConstants.VIDEO_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        type: videoConstants.VIDEO_DETAILS_REQUEST,
      };
    case videoConstants.VIDEO_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        videoLink: action.payload.data.videoLink,
        type: videoConstants.VIDEO_DETAILS_SUCCESS,
      };
    case videoConstants.VIDEO_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        type: videoConstants.VIDEO_DETAILS_FAIL,
      };
    case videoConstants.VIDEO_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        type: videoConstants.VIDEO_DELETE_REQUEST,
      };
    case videoConstants.VIDEO_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        type: videoConstants.VIDEO_DELETE_SUCCESS,
      };
    case videoConstants.VIDEO_DELETE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.data,
        type: videoConstants.VIDEO_DELETE_FAIL,
      };
    case videoConstants.VIDEO_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        type: videoConstants.VIDEO_UPDATE_REQUEST,
      };
    case videoConstants.VIDEO_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        type: videoConstants.VIDEO_UPDATE_SUCCESS,
      };
    case videoConstants.VIDEO_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        type: videoConstants.VIDEO_UPDATE_FAIL,
      };
    case videoConstants.VIDEO_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
        type: videoConstants.VIDEO_CREATE_REQUEST,
      };
    case videoConstants.VIDEO_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        type: videoConstants.VIDEO_CREATE_SUCCESS,
      };
    case videoConstants.VIDEO_CREATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        type: videoConstants.VIDEO_CREATE_FAIL,
      };
    case videoConstants.VIDEO_WATCHED_REQUEST:
      return {
        ...state,
        loading: true,
        type: videoConstants.VIDEO_WATCHED_REQUEST,
      };
    case videoConstants.VIDEO_WATCHED_SUCCESS:
      return {
        ...state,
        loading: false,
        type: videoConstants.VIDEO_WATCHED_SUCCESS,
      };
    case videoConstants.VIDEO_WATCHED_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.data,
        type: videoConstants.VIDEO_WATCHED_FAIL,
      };
    case videoConstants.VIDEO_AUTOPLAY_REQUEST:
      return {
        ...state,
        loading: true,
        type: videoConstants.VIDEO_AUTOPLAY_REQUEST,
      };
    case videoConstants.VIDEO_AUTOPLAY_SUCCESS:
      return {
        ...state,
        loading: false,
        videoLink: action.payload.data.videoLink,
        nextVideoId: action.payload.data.videoId,
        nextVideoPlayOrder: action.payload.data.playOrder,
        type: videoConstants.VIDEO_AUTOPLAY_SUCCESS,
      };
    case videoConstants.VIDEO_AUTOPLAY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        type: videoConstants.VIDEO_AUTOPLAY_FAIL,
      };
    case videoConstants.VIDEO_COUNTER_REQUEST:
      return {
        ...state,
        loading: true,
        type: videoConstants.VIDEO_COUNTER_REQUEST,
      };
    case videoConstants.VIDEO_COUNTER_SUCCESS:
      return {
        ...state,
        loading: false,
        videoCounter: action.payload.data.videoCounter,
        type: videoConstants.VIDEO_COUNTER_SUCCESS,
      };
    case videoConstants.VIDEO_COUNTER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        type: videoConstants.VIDEO_COUNTER_FAIL,
      };
    default:
      return state;
  }
};
